export default "__VITE_ASSET__D$dc3Hyq__"